/* SolarHome theme — small, dependency-free enhancements */
(function () {
  'use strict';

  /* ---------- Countdown in announcement bar ---------- */
  function initCountdowns() {
    document.querySelectorAll('[data-countdown]').forEach(function (el) {
      var end = Date.parse(el.getAttribute('data-countdown'));
      if (isNaN(end)) { el.hidden = true; return; }
      var labels = (el.getAttribute('data-labels') || 'T|Std|Min|Sek').split('|');
      function pad(n) { return String(n).padStart(2, '0'); }
      function tick() {
        var diff = Math.max(0, end - Date.now());
        if (diff === 0) {
          var bar = el.closest('[data-hide-when-expired]');
          if (bar) { bar.hidden = true; } else { el.hidden = true; }
          return;
        }
        var s = Math.floor(diff / 1000);
        var d = Math.floor(s / 86400); s -= d * 86400;
        var h = Math.floor(s / 3600); s -= h * 3600;
        var m = Math.floor(s / 60); s -= m * 60;
        el.textContent = pad(d) + ' ' + labels[0] + ' · ' + pad(h) + ' ' + labels[1] + ' · ' + pad(m) + ' ' + labels[2] + ' · ' + pad(s) + ' ' + labels[3];
        setTimeout(tick, 1000);
      }
      tick();
    });
  }

  /* ---------- Quantity steppers ---------- */
  function initQuantity(root) {
    (root || document).querySelectorAll('[data-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      wrap.querySelectorAll('[data-qty-change]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = parseInt(btn.getAttribute('data-qty-change'), 10);
          var min = parseInt(input.min || '0', 10);
          var max = input.max ? parseInt(input.max, 10) : Infinity;
          var next = Math.min(max, Math.max(min, (parseInt(input.value, 10) || 0) + step));
          input.value = next;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ---------- Auto-submit (cart quantities, sort) ---------- */
  function initAutoSubmit() {
    document.querySelectorAll('[data-auto-submit]').forEach(function (field) {
      field.addEventListener('change', function () {
        var form = field.form || field.closest('form');
        if (form) form.submit();
      });
    });
  }

  /* ---------- Product gallery ---------- */
  function initGallery(root) {
    var main = root.querySelector('[data-main-media]');
    if (!main) return;
    var mainImg = main.querySelector('img');
    var thumbs = root.querySelectorAll('[data-thumb]');
    var zoom = root.querySelector('[data-zoom-link]');
    var optionImage = root.querySelector('[data-option-image] img');
    function show(thumb) {
      if (!mainImg) return;
      mainImg.src = thumb.getAttribute('data-src');
      mainImg.srcset = thumb.getAttribute('data-srcset') || '';
      mainImg.alt = thumb.getAttribute('data-alt') || '';
      if (zoom && thumb.getAttribute('data-zoom')) zoom.href = thumb.getAttribute('data-zoom');
      thumbs.forEach(function (t) { t.setAttribute('aria-current', t === thumb ? 'true' : 'false'); });
    }
    root.addEventListener('variant:change', function (e) {
      var variant = e.detail;
      if (!optionImage || !variant || !variant.featured_media) return;
      var match = root.querySelector('[data-thumb][data-media-id="' + variant.featured_media.id + '"]');
      if (match) { optionImage.src = match.getAttribute('data-src'); optionImage.srcset = ''; }
    });
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () { show(thumb); });
    });
    root.addEventListener('variant:change', function (e) {
      var variant = e.detail;
      if (!variant || !variant.featured_media) return;
      var match = root.querySelector('[data-thumb][data-media-id="' + variant.featured_media.id + '"]');
      if (match) show(match);
    });
  }

  /* ---------- Variant picker ---------- */
  function initVariantPicker(root) {
    var dataEl = root.querySelector('[data-product-json]');
    var form = root.querySelector('[data-product-form]');
    if (!dataEl || !form) return;
    var product = JSON.parse(dataEl.textContent);
    var idInput = form.querySelector('input[name="id"]');
    var addBtn = form.querySelector('[data-add-button]');
    var priceEl = root.querySelector('[data-price]');
    var compareEl = root.querySelector('[data-compare-price]');
    var savingsEl = root.querySelector('[data-savings]');
    var stockEl = root.querySelector('[data-stock]');
    var fieldsets = root.querySelectorAll('[data-option-index]');
    var moneyFormat = root.getAttribute('data-money-format') || 'CHF {{amount}}';
    var strings = {
      add: addBtn ? addBtn.getAttribute('data-label-add') : '',
      soldOut: addBtn ? addBtn.getAttribute('data-label-sold-out') : '',
      unavailable: addBtn ? addBtn.getAttribute('data-label-unavailable') : ''
    };

    function formatMoney(cents) {
      var value = (cents / 100).toFixed(2);
      var parts = value.split('.');
      var withSep = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '’') + '.' + parts[1];
      var plain = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
      var noDecimals = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '’');
      return moneyFormat
        .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/, withSep)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDecimals)
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','))
        .replace(/\{\{\s*amount\s*\}\}/, plain);
    }

    function selectedOptions() {
      return Array.prototype.map.call(fieldsets, function (fs) {
        var checked = fs.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }

    function findVariant(opts) {
      return product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }

    function markAvailability(opts) {
      fieldsets.forEach(function (fs, index) {
        fs.querySelectorAll('input').forEach(function (input) {
          var test = opts.slice();
          test[index] = input.value;
          var v = findVariant(test);
          input.classList.toggle('is-unavailable', !v || !v.available);
        });
        var label = fs.querySelector('[data-selected-value]') || root.querySelector('[data-option-label="' + index + '"]');
        if (label) label.textContent = opts[index] || '';
      });
    }

    function update() {
      var opts = selectedOptions();
      var variant = findVariant(opts);
      markAvailability(opts);

      if (!variant) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = strings.unavailable; }
        return;
      }
      idInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (compareEl) {
        if (onSale) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      if (savingsEl) {
        if (onSale) {
          var tpl = savingsEl.getAttribute('data-savings-template') || '-[amount]';
          savingsEl.textContent = tpl.replace('[amount]', formatMoney(variant.compare_at_price - variant.price));
          savingsEl.hidden = false;
        } else {
          savingsEl.hidden = true;
        }
      }
      if (stockEl) {
        stockEl.textContent = variant.available ? stockEl.getAttribute('data-label-in') : stockEl.getAttribute('data-label-out');
        stockEl.classList.toggle('stock-dot--out', !variant.available);
      }
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? strings.add : strings.soldOut;
      }
      root.querySelectorAll('[data-variant-text]').forEach(function (el) {
        var i = parseInt(el.getAttribute('data-variant-text'), 10);
        el.textContent = opts[i] || '';
      });

      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
      root.dispatchEvent(new CustomEvent('variant:change', { detail: variant }));
    }

    fieldsets.forEach(function (fs) {
      fs.addEventListener('change', update);
    });
    markAvailability(selectedOptions());
  }

  /* ---------- Lazy video embeds ---------- */
  function initVideos() {
    document.querySelectorAll('[data-video-poster]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var src = btn.getAttribute('data-video-src');
        if (!src) return;
        var iframe = document.createElement('iframe');
        iframe.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'autoplay=1';
        iframe.title = btn.getAttribute('data-video-title') || '';
        iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        iframe.allowFullscreen = true;
        btn.replaceWith(iframe);
      });
    });
  }

  /* ---------- Tabs ---------- */
  function initTabs(root) {
    (root || document).querySelectorAll('[data-tabs]').forEach(function (wrap) {
      var tabs = Array.prototype.slice.call(wrap.querySelectorAll('[role="tab"]'));
      function select(tab, focus) {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          var panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
        if (focus) tab.focus();
      }
      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { select(tab, false); });
        tab.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { e.preventDefault(); select(tabs[(i + 1) % tabs.length], true); }
          if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { e.preventDefault(); select(tabs[(i - 1 + tabs.length) % tabs.length], true); }
        });
      });
    });
  }

  /* ---------- Carousels ---------- */
  function initCarousels(root) {
    (root || document).querySelectorAll('[data-carousel]').forEach(function (wrap) {
      var track = wrap.querySelector('[data-carousel-track]');
      if (!track) return;
      function step() {
        var first = track.firstElementChild;
        return first ? first.getBoundingClientRect().width + 16 : 300;
      }
      var prev = wrap.querySelector('[data-carousel-prev]');
      var next = wrap.querySelector('[data-carousel-next]');
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    });
  }

  /* ---------- Product video dialog ---------- */
  function initVideoDialogs(root) {
    (root || document).querySelectorAll('[data-video-dialog-open]').forEach(function (btn) {
      var dialog = document.getElementById(btn.getAttribute('data-video-dialog-open'));
      if (!dialog || typeof dialog.showModal !== 'function') return;
      var frame = dialog.querySelector('.video-dialog__frame');
      function close() { dialog.close(); }
      btn.addEventListener('click', function () {
        frame.innerHTML = '';
        var iframe = document.createElement('iframe');
        iframe.src = dialog.getAttribute('data-src');
        iframe.title = dialog.getAttribute('aria-label') || '';
        iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        iframe.allowFullscreen = true;
        frame.appendChild(iframe);
        dialog.showModal();
      });
      dialog.addEventListener('close', function () { frame.innerHTML = ''; });
      dialog.addEventListener('click', function (e) { if (e.target === dialog) close(); });
      var closeBtn = dialog.querySelector('[data-video-dialog-close]');
      if (closeBtn) closeBtn.addEventListener('click', close);
    });
  }

  /* ---------- Mega menu backdrop ---------- */
  function initMegaMenus(root) {
    (root || document).querySelectorAll('[data-header]').forEach(function (wrap) {
      var items = Array.prototype.slice.call(wrap.querySelectorAll('.header__nav-item--has-menu'));
      function anyOpen() { return items.some(function (i) { return i.classList.contains('is-open'); }); }
      function sync() { wrap.classList.toggle('is-mega-open', anyOpen() || items.some(function (i) { return i.matches(':hover') && i.classList.contains('header__nav-item--mega'); })); }
      function closeAll(except) {
        items.forEach(function (i) {
          if (i !== except) {
            i.classList.remove('is-open');
            var a = i.querySelector(':scope > a');
            if (a) a.setAttribute('aria-expanded', 'false');
          }
        });
      }
      items.forEach(function (item) {
        var top = item.querySelector(':scope > a');
        if (!top) return;
        top.setAttribute('aria-expanded', 'false');
        /* Click on a top-level item opens/closes its panel instead of leaving the page */
        top.addEventListener('click', function (e) {
          e.preventDefault();
          var willOpen = !item.classList.contains('is-open');
          closeAll(item);
          item.classList.toggle('is-open', willOpen);
          top.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
          sync();
        });
        item.addEventListener('mouseenter', function () {
          if (anyOpen() && !item.classList.contains('is-open')) {
            closeAll(item);
            item.classList.add('is-open');
            top.setAttribute('aria-expanded', 'true');
          }
          sync();
        });
        item.addEventListener('mouseleave', function () { setTimeout(sync, 0); });
        item.addEventListener('keydown', function (e) {
          if (e.key === 'Escape') { closeAll(); sync(); top.focus(); }
        });
      });
      /* Click anywhere outside the menu closes it */
      document.addEventListener('click', function (e) {
        if (!e.target.closest('.header__nav-item--has-menu')) { closeAll(); sync(); }
      });
      /* Dimmed backdrop below the header also closes on click */
      wrap.addEventListener('click', function (e) {
        if (e.target === wrap) { closeAll(); sync(); }
      });
    });
  }

  function init() {
    initMegaMenus();
    initCountdowns();
    initQuantity();
    initAutoSubmit();
    initVideos();
    initTabs();
    initCarousels();
    initVideoDialogs();
    document.querySelectorAll('[data-product]').forEach(function (root) {
      initGallery(root);
      initVariantPicker(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Re-initialise when sections are re-rendered in the theme editor */
  document.addEventListener('shopify:section:load', function (e) {
    initCountdowns();
    initMegaMenus(e.target);
    initQuantity(e.target);
    initVideos();
    initTabs(e.target);
    initCarousels(e.target);
    initVideoDialogs(e.target);
    e.target.querySelectorAll('[data-product]').forEach(function (root) {
      initGallery(root);
      initVariantPicker(root);
    });
  });
})();
